import React, { Component } from 'react';
import queryString from 'querystring';
import { API_BASE_URL } from '../constatns';
import PrivacyPolicyKR from './PrivacyPolicyKR';
import PrivacyPolicyJA from './PrivacyPolicyJA';

class PrivacyPolicyPage extends Component {
  constructor(props) {
    super(props);
    const param = queryString.parse(this.props.location.search.replace('?', ''));
    this.state = {
      lang: param.lang,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <div className="share-container">
        {this.state.lang === 'jp' || this.state.lang === 'ja' ? <PrivacyPolicyJA /> : <PrivacyPolicyKR />}
      </div>
    );
  }
}

export default PrivacyPolicyPage;
